import React from "react";
import PropTypes from "prop-types";
import cross from "./cross.svg";
import css from "./AnchorMenu.module.scss";
import cn from "classnames";
import scrollToElement from "scroll-to-element";
import Icon from "components/Icon";
import throttle from 'lodash/throttle';

const MobileToggle = ({ onClick, isActiveOnMobile, openText, closeText }) => {
    const buttonText = (
        <div className={css.toggle} onClick={onClick}>
            <span className={css.toggleText}>
                {openText}
                <Icon icon="arrow-down" className={css.arrow} />
            </span>
        </div>
    );

    const crossIcon = (
        <div className={css.toggle} onClick={onClick}>
            <img className={css.toggleCross} alt={closeText} src={cross} />
        </div>
    );

    return isActiveOnMobile ? crossIcon : buttonText;
};

function getAllElementsWithAttribute(attribute) {
    var matchingElements = [];
    var allElements = document.getElementsByTagName("*");
    for (var i = 0, n = allElements.length; i < n; i++) {
        if (allElements[i].getAttribute(attribute) !== null) {
            matchingElements.push(allElements[i]);
        }
    }
    return matchingElements;
}

class AnchorMenu extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isActiveOnMobile: false,
            active: null,
            scrollingItem: null
        };

        this.activeOnMobile = this.activeOnMobile.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.handleScroll - this.handleScroll.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
    }

    static propTypes = {
        goToTopButtonText: PropTypes.string,
        logoFallbackText: PropTypes.string,
        logo: PropTypes.shape({
            url: PropTypes.string,
            altText: PropTypes.string
        }),
        anchorHeading: PropTypes.string,
        anchors: PropTypes.arrayOf(
            PropTypes.shape({
                blockId: PropTypes.number.isRequired,
                title: PropTypes.string.isRequired
            })
        ).isRequired
    };

    activeOnMobile() {
        this.setState({ isActiveOnMobile: !this.state.isActiveOnMobile });
    }

    scrollToAnchor = (target) => {
        const selector = `[data-block="${target}"]`;
        const element = document.querySelector(selector);
        var body = document.body;

        body.classList.add("anchor-is-scrolling");
        this.setState({ scrollingItem: target});
        this.setState({ active: target });
     
        if (target && element) {
            window.history.pushState(null, null, `#${target}`);
            scrollToElement(selector, {
                offset: -69,
                ease: "linear",
                duration: 500
            });
        }

        this.setState({ isActiveOnMobile: false });
    }

    handleOnClick = e => {
        e.preventDefault();
        const { target } = e.currentTarget.dataset;
        this.scrollToAnchor(target);
    };

    scrollToTop(speed) {
        var body = document.body;
        body.classList.add("logo-is-clicked");

        scrollToElement(".site", {
            offset: 0,
            ease: "linear",
            duration: speed
        });

        this.setState({ isActiveOnMobile: false });
    }

    scrollToAnchorOnPageLoad = () => {
        const hash = window.location.hash.slice(1);
  
        if (hash) {
            setTimeout(() => {
                this.scrollToAnchor(hash);
            }, 500);
        }
    }

    componentDidMount() {
        (typeof window !== 'undefined') && window.addEventListener("scroll", this.handleScroll);
        this.scrollToAnchorOnPageLoad();
    }

    componentWillUnmount() {
        (typeof window !== 'undefined') && window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = throttle(() => {
        let active = null;
        var el = getAllElementsWithAttribute('data-block');
        var selectedItem = this.state.scrollingItem;
        var body = document.body;
        var header = document.querySelector('.site-header');
        var $this = this;
        var $mainContainer = document.querySelector('#main');
        var $footer = document.querySelector('.footer');
        var siteHeight = $mainContainer.offsetHeight + $footer.offsetHeight;
        var windowOffsetPlusMenuHeight = window.pageYOffset + 70;
        var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var logoWasClicked = body.classList.contains("logo-is-clicked");

        var disableHeaderAnimation = function(){
            body.classList.remove("anchor-is-scrolling");
            header.classList.add("scroll-down");
            body.classList.remove("logo-is-clicked");
        };
        
        if(logoWasClicked){
            setTimeout(() => disableHeaderAnimation(), 0);
        }else{
            if(selectedItem){
                const selector = `[data-block="${selectedItem}"]`;
                const element = document.querySelector(selector);
                $this.setState({ active: selectedItem });

                if( element.offsetTop <= windowOffsetPlusMenuHeight &&  windowOffsetPlusMenuHeight <= (element.offsetTop + element.offsetHeight) || window.pageYOffset - 70 === siteHeight - vh){               
                    $this.setState({ active: selectedItem });
                    $this.setState({scrollingItem: false});
                    
                    //timeout (0) to follow sequence
                    setTimeout(() => disableHeaderAnimation(), 0);
                }
            }else{              
                for(let i = 0; i < el.length; i++){
                    active = el[i].getAttribute('data-block');
                    if(window.pageYOffset + 70 >= (el[i].offsetTop) &&  window.pageYOffset + 70  < (el[i].offsetTop + el[i].offsetHeight)  ){
                        break;
                    }else{
                        active= null;
                    }
                }
        
                this.setState({ active: active });
            }
        }
    }, 0);

    render() {
        const {
            logo,
            logoFallbackText,
            anchorHeading,
            anchors,
            goToTopButtonText
        } = this.props;

        const { isActiveOnMobile, active} = this.state;

        const menuClassName = cn(css.menu, {
            activeMobile: isActiveOnMobile
        });

        return logo || logoFallbackText || anchors || goToTopButtonText ? (
            <nav className={menuClassName}>
                <div className={css.inner}>
                    <div className={css.header}>
                        <div className={css.logo}>
                        <button
                            title={goToTopButtonText}
                            className={cn("scroll-button")}
                            onClick={() => {
                                this.scrollToTop(500);
                            }}
                        >
                            {logo ?
                                <img alt={logo.altText ? logo.altText : ''} src={logo.url} className={css.logoImage}  />
                                :
                                <h2 className={css.logoFallbackText}>{logoFallbackText}</h2>
                            }
                        </button>
                            
                        </div>
                        <MobileToggle
                            onClick={this.activeOnMobile}
                            isActiveOnMobile={isActiveOnMobile}
                            openText={anchorHeading}
                            closeText="close"
                        />
                    </div>
                    <strong className={css.anchorsHeading}>
                        {anchorHeading}
                    </strong>
                    <div className={css.listWrapper}>
                        <ul className={css.list}>
                            {anchors &&
                                anchors.map((l) => (
                                    <li key={l.blockId}>
                                        <button
                                            data-target={l.blockId}
                                            onClick={this.handleOnClick}
                                            className={cn(css.button, {
                                                [css.active]: active == l.blockId
                                            })}
                                        >
                                            {l.title}
                                        </button>
                                    </li>
                                ))}
                        </ul>
                    </div>
                    <div className={css.scrollToTop}>
                        <button
                            title={goToTopButtonText}
                            className={cn("scroll-button")}
                            onClick={() => {
                                this.scrollToTop(500);
                            }}
                        >
                            {goToTopButtonText}
                        </button>
                    </div>
                </div>
            </nav>
        ) : null;
    }
}
export default AnchorMenu;



// WEBPACK FOOTER //
// ./src/components/AnchorMenu/AnchorMenu.jsx